import { render, staticRenderFns } from "./InputTel.vue?vue&type=template&id=ce136a5a&lang=pug"
import script from "./InputTel.vue?vue&type=script&lang=js"
export * from "./InputTel.vue?vue&type=script&lang=js"
import style0 from "./InputTel.vue?vue&type=style&index=0&id=ce136a5a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports